import { get, post } from '@aiptyg/api-client';
import { base, query, type Page } from './service';

export type FeedbackStatus = 'open' | 'in_progress' | 'resolved';
export interface FeedbackTicket {
  id: number;
  agent_id: number;
  agent_name?: string;
  portal_task_id?: number;
  assignment_id?: number;
  category: 'general' | 'task' | 'submission_review';
  subject: string;
  body: string;
  status: FeedbackStatus;
  version: number;
  created_at: string;
  updated_at: string;
}
export interface FeedbackDetail {
  ticket: FeedbackTicket;
  messages: { id: number; ticket_id: number; actor_kind: string; body: string; created_at: string }[];
}
type Filters = Record<string, string | number | undefined>;

export function formatAgencyDateTime(value: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '—';
  return date.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  });
}

export const listAgentFeedback = (params: Filters) =>
  get<Page<FeedbackTicket>>(`${base}/agent-feedback?${query(params)}`);
export const getAgentFeedback = (id: number) =>
  get<FeedbackDetail>(`${base}/agent-feedback/${id}`);
export const replyAgentFeedback = (id: number, data: { body?: string; status?: FeedbackStatus; expected_version: number }) =>
  post<FeedbackDetail>(`${base}/agent-feedback/${id}/messages`, data);

export const feedbackStatuses: Record<FeedbackStatus, string> = { open: '待处理', in_progress: '处理中', resolved: '已解决' };
export const feedbackCategories = { general: '一般反馈', task: '任务问题', submission_review: '申请复核' };
export const submissionStatuses: Record<string, string> = {
  assigned: '已领取', submitted: '待审核', approved: '已通过', settled: '已结算', rejected: '已驳回', expired: '已过期', cancelled: '已取消',
};
